import { useCallback } from "react";
import { getDateFormat } from "./dateTimeFormatUtils";

export const PLAYER_BIRTHDAY_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
	year: "numeric",
	month: "numeric",
	day: "numeric",
};

export function formatPlayerBirthdayForDisplay(date: string | null | undefined, locale: string): string {
	if (date == null || date === "") {
		return "-";
	}
	try {
		// Parse dd-mm-yyyy (from backend DATE_FORMAT) - new Date() cannot parse it
		const dmyMatch = String(date).match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
		const parsed = dmyMatch
			? new Date(parseInt(dmyMatch[3], 10), parseInt(dmyMatch[2], 10) - 1, parseInt(dmyMatch[1], 10))
			: new Date(date);
		if (Number.isNaN(parsed.getTime())) {
			return "-";
		}
		return new Intl.DateTimeFormat(getDateFormat(locale), PLAYER_BIRTHDAY_DATE_FORMAT_OPTIONS).format(parsed);
	} catch {
		return "-";
	}
}

export function useFormattedPlayerBirthday(locale: string) {
	return useCallback(
		(date: string | null | undefined) => formatPlayerBirthdayForDisplay(date, locale),
		[locale],
	);
}
